import React from 'react';
import './../../pages/Tela_Teste_Conexão/style.css';

import Cadastro_ME from './../../components/Forms_ProfissionalDaSaude/Cadastro_ME/';
import Agendamento_CPE from './../../components/Forms_ProfissionalDaSaude/Agendamento';
import Receita from './../../components/Forms_ProfissionalDaSaude/Receita';
import Form_PM from './../../components/Forms_ProfissionalDaSaude/Prontuario_DeMonitoracao';

export default function Tela_TesteConnection(){    
    return(
        <>   
            <div id ="centralize-data">                   
                <Cadastro_ME />
                <br></br>
                <Agendamento_CPE />
                <br></br>
                <Receita />
                <br></br>
                <Form_PM />
            </div>   
                          
        </>
    );
}